__turbopack_context__.v({
  "Tag": "app-tag-module__v-gUpW__Tag",
});
